import clsx from 'clsx'
import React from 'react'

import Button from '../Button/Button'
import Icon from '../Icon/Icon'

type ButtonProps = React.ComponentProps<typeof Button>

interface LoadingButtonProps extends Omit<ButtonProps, 'children'> {
  children: React.ReactNode
  loading?: boolean
  spinnerClassName?: string
  contentClassName?: string
}

function LoadingButton({
  children,
  loading = false,
  disabled,
  className,
  spinnerClassName,
  contentClassName,
  ...rest
}: LoadingButtonProps) {
  const isDisabled = disabled || loading
  // Need to keep the inner content so the button doesn't collapse on loading
  return (
    <Button
      disabled={isDisabled}
      aria-busy={loading || undefined}
      className={className}
      {...rest}
    >
      <span
        className={clsx(
          'relative inline-grid place-items-center',
          contentClassName,
        )}
      >
        <span className={loading ? 'opacity-0' : undefined}>{children}</span>
        {loading && (
          <Icon
            icon="loading"
            aria-label="Loading"
            className={clsx(
              'absolute top-0 size-5 animate-spin',
              spinnerClassName,
            )}
          />
        )}
      </span>
    </Button>
  )
}

export default LoadingButton
